'use client'

import { type ChangeEvent, useCallback, useMemo, useState } from 'react'

import type { MobileCardItem } from '@/core/types/cardNavigation.type'

import type { CardData } from '../../../types'
import { CardInstallation } from '../../CardInstallation'
import { CardHeader } from '../CardHeader'
import { SearchFilterBar } from '../SearchFilter/SearchFilter'

import { ClassViewList } from './ClassViewList'

import styles from './ClassView.module.scss'

export function ClassView({
  libraryData,
  installationCardKey,
  technologies,
  suggestedTechnologies,
  selectedTechnology,
  installationTabs,
  graftabilityReport,
  onTechnologyChange,
  onConnectionStringGenerator,
  mobileHeaderInfo,
  mobileCards,
  classData,
  onMobileBack,
  onMobileCardClick,
}: CardData) {
  const [searchQuery, setSearchQuery] = useState('')

  const handleSearchChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value)
  }, [])

  const handleSearchClear = useCallback(() => {
    setSearchQuery('')
  }, [])

  const filteredCards = useMemo<MobileCardItem[] | undefined>(() => {
    if (!searchQuery.trim() || !mobileCards) return mobileCards
    const query = searchQuery.toLowerCase()
    return mobileCards.filter(
      (card: MobileCardItem) =>
        card.name.toLowerCase().includes(query) || card.description?.toLowerCase().includes(query)
    )
  }, [mobileCards, searchQuery])

  return (
    <>
      <div className={styles.header}>
        {libraryData && (
          <CardInstallation
            installationCardKey={installationCardKey}
            technologies={technologies}
            suggestedTechnologies={suggestedTechnologies}
            selectedTechnology={selectedTechnology}
            tabs={installationTabs}
            libraryData={libraryData}
            graftabilityReport={graftabilityReport}
            onTechnologyChange={onTechnologyChange}
            onConnectionStringGenerator={onConnectionStringGenerator}
          />
        )}
        <CardHeader
          label={mobileHeaderInfo.label}
          count={mobileCards?.length ?? 0}
          description={classData?.name !== mobileHeaderInfo.label ? classData?.namespace : undefined}
          onBack={onMobileBack}
        />
      </div>
      <SearchFilterBar
        searchQuery={searchQuery}
        placeholder="Search methods..."
        onSearchChange={handleSearchChange}
        onSearchClear={handleSearchClear}
        filterButtonDisabled
      />
      <ClassViewList searchQuery={searchQuery} filteredCards={filteredCards} onCardClick={onMobileCardClick} />
    </>
  )
}
